import { getAuthToken } from '../../clearances/utils/localStorageService';
import decode from 'jwt-decode';
import { useDispatch, useSelector } from 'react-redux';
import { setSessionStart } from '../../clearances/store/auth';
import moment from 'moment';
import { navigate } from '@reach/router';

/**
 * AuthVerify Component: Verify the expiration time of the session and logout if the time is over
 * @returns
 * @param props
 */
export const AuthVerify = (props) => {
    const dispatch = useDispatch();
    const { sessionStart } = useSelector((s) => s.auth);
    const token = getAuthToken();

    if (sessionStart === '') {
        dispatch(setSessionStart(moment.utc().toISOString()));
    }

    if (token) {
        const decodedJwt = decode(token);
        if (decodedJwt.exp * 1000 < Date.now()) {
            dispatch(setSessionStart(''));
            props.logOut();
        } else {
            navigate(localStorage.getItem('activePanel'));
        }
    }
    return null;
};
